import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';

import columnDefinitions from '../../shared/columnDefinitions/taxAccounting';
import TaxAccountingSettingsAdminColumnRenderer from './taxAccountingSettingsAdminColumnRenderer.component';

import { withPermissions, permissions } from '../../shared/authorization';

import AddTaxAccountingModal from './addTaxAccountingModal.component';
import DeleteTaxAccountingModal from './deleteTaxAccountingModal.component';

import {
  sharedActions,
} from './store/actions';
import config from '../../config';
import downloadTaxAccountingXlsx from './downloadTaxAccountingXlsx';

type TaxAccountingSettingsPageParams = {
  canModifyInSelectedPeriod: boolean
}

const TaxAccountingSettingsPage = ({
  canModifyInSelectedPeriod,
}: TaxAccountingSettingsPageParams) => {
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Tax_Accounting_${periodName}`,
    []);
  return (
    <AdminImportPage
      pageName={adminPageNames.TAX_ACCOUNTING}
      canModify={canModifyInSelectedPeriod}
      AddEditEntityModal={AddTaxAccountingModal}
      RemoveEntityModal={DeleteTaxAccountingModal}
      adminColumnRenderer={TaxAccountingSettingsAdminColumnRenderer}
      addEntityMessage="Add Tax Accounting"
      columnDefs={columnDefinitions}
      actions={sharedActions}
      comparatorConfig={{
        idField: 'taxDescription',
      }}
      exportToExcel={downloadTaxAccountingXlsx}
      generateTemplateFileName={generateTemplateFileName}
      templatePath={config.templates.TAX_ACCOUNTING}
      pageTitle={adminPageTitles.TAX_ACCOUNTING}
      singularTitle
    />);
};

TaxAccountingSettingsPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.TAX_ACCOUNTING_SETTINGS)(TaxAccountingSettingsPage);
